import * as CONST from "./constant";

const intialState = {
  data: {},
  error: null,
  vehicleTypes: null,
};

const VehiclesReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.VEHICLE_TYPE_SUCCESS:
      return {
        ...state,
        vehicleTypes: payload.data,
        error: null,
      };
    case CONST.VEHICLE_TYPE_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
      break;
  }
};

export default VehiclesReducer;
